import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  WritableSignal,
} from '@angular/core';
import { FellowTravelerStore } from '../../../../services/api/fellow-traveler/fellow-traveler-store.service';
import { CorporateDesignService } from '../../../../services/corporate-design/corporate-design.service';
import { WebTextStore } from '../../../../services/api/text/web-text-store.service';
import { FilterTextsPipe } from '../../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { SectionComponent } from '../../../../components/layout/section/section.component';
import { SectionHeaderComponent } from '../../../../components/layout/section/section-header/section-header.component';
import { SectionHeadlineComponent } from '../../../../components/layout/section/section-header/section-headline/section-headline.component';
import { EEntityType, ERelationType, IFellowTravelerDto } from '@web/dtos';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountFellowTravelerItemComponent } from '../../../../components/data-display/account-fellow-traveler-item/account-fellow-traveler-item.component';
import { ButtonComponent } from '../../../../components/feedback/button/button.component';

@Component({
  selector: 'aw-account-fellow-travelers-page',
  imports: [
    FilterTextsPipe,
    LanguagePipe,
    SectionComponent,
    SectionHeaderComponent,
    SectionHeadlineComponent,
    FormsModule,
    ReactiveFormsModule,
    AccountFellowTravelerItemComponent,
    ButtonComponent,
  ],
  templateUrl: './account-fellow-travelers-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountFellowTravelersPageComponent {
  protected readonly fellowTravelerStore: FellowTravelerStore =
    inject(FellowTravelerStore);
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly textStore: WebTextStore = inject(WebTextStore);

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;

  protected readonly createFellowTraveler: WritableSignal<IFellowTravelerDto> =
    signal<IFellowTravelerDto>({
      salutation: null,
      firstName: '',
      lastName: '',
      dateOfBirth: null,
    });
  protected readonly isCreating: WritableSignal<boolean> = signal(false);

  protected createNewFellowTraveler(): void {
    this.isCreating.set(true);
  }

  protected finishCreatingFellowTraveler(): void {
    this.isCreating.set(false);
  }
}
